document.addEventListener('DOMContentLoaded', function() {
    //const inshurance
    const productId = '9447779205418';
    const cookieName = 'dl_inshurance';    
    const productHandle = 'order-insurance'; 

    // func check cart
    function fetchCart() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => cart);
    }
    
    // get data product
    function fetchProduct(handle) {
        return fetch(`/products/${handle}.js`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Error getting product: ${response.statusText}`);
                }
                return response.json();
            })
            .then(product => product)
            .catch(error => {
                console.error('Error getting request product:', error);
            });
    }

    // add product to cart    
    function addToCart(variantId) {
        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1,
                isInsurance: true,
            })
        })
        .then(response => response.json())
        .then(data => {
            console.log('Product added to cart:', data);
        })
        .catch(error => {
            console.error('Error added product to cart:', error);
        });
    }  
  
    // check cookie
    function checkCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    function checkConditionsAndAddToCart() {
        fetchCart().then(cart => {
            const hasProduct = cart.items.some(item => item.product_id === parseInt(productId));
            const cookieExists = checkCookie(cookieName);
            const cartNotEmpty = cart.items.length > 0;
            
            
              
            //if (!hasProduct && !cookieExists) {
            if (!hasProduct && !cookieExists && cartNotEmpty) {
                fetchProduct(productHandle).then(product => {
                    // check variant
                    if (product.variants.length > 0) {
                        const variantId = product.variants[0].id;
                        console.error('Product added to cart(test)');
                        addToCart(variantId);
                    } else {
                        console.error('Cant find Insurance variants product');
                    }
                });
            } else {
                if (hasProduct) {
                    console.log('Insurance already in');
                }
                if (cookieExists) {
                    console.log('Insurance already deleted');
                }
            }
        });
    }
  
  
    // reg func check
    function containsWord(str, word) {
        return str.toLowerCase().includes(word.toLowerCase());
    }

    // remove paypal
    function hidePaypalButton() {
        var paypalButtons = document.querySelectorAll('[data-shopify="payment-button"]');
        paypalButtons.forEach(function(button) {          
            // create warning msg
            var warningMessage = document.createElement('div');
            warningMessage.textContent = 'PayPal Express Checkout is unavailable for this order. Cuban products cannot be purchased using PayPal.';
            //Do not use "PayPal Express Checkout" for this order.
            warningMessage.style.color = 'red';
            warningMessage.style.fontWeight = 'bold';
            warningMessage.style.marginTop = '11px';
            warningMessage.class="hdt-product-info__item";

            // append msg and remove button
            var parentElement = button.parentElement;
            if (parentElement) {
                parentElement.appendChild(warningMessage);
            }
            button.remove();
        });
    }    

    // check product and desc
    function checkProductDetails() {
        var productTitleElement = document.querySelector('.hdt-product__title'); 
        var productDescriptionElement = document.querySelector('.hdt-product-tab__content'); 
        var productContryElement = document.querySelector('.hdt-product_country'); 
      

        var shouldHidePaypalButton = false;

        if (productTitleElement) {
            var productTitle = productTitleElement.textContent;
            shouldHidePaypalButton = containsWord(productTitle, 'Cuba') || containsWord(productTitle, 'Havana') || containsWord(productTitle, 'GUYANA') ;
        }

        if (!shouldHidePaypalButton && productDescriptionElement) {
            var productDescription = productDescriptionElement.textContent;
            shouldHidePaypalButton = containsWord(productDescription, 'Cuba') || containsWord(productDescription, 'Havana') || containsWord(productDescription, 'GUYANA') ;
        }

        if (!shouldHidePaypalButton && productContryElement) {
            var productCountry = productContryElement.textContent;
            shouldHidePaypalButton = containsWord(productCountry, 'Cuba') || containsWord(productCountry, 'Havana') || containsWord(productCountry, 'GUYANA') ;
        }      
      
        return shouldHidePaypalButton;
    }

    // view all events
    var observer = new MutationObserver(function(mutations) {
        if (checkProductDetails()) {
            //hidePaypalButton();
        }
        //checkConditionsAndAddToCart();
    });

    // start on body
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // first start when load
    if (checkProductDetails()) {
      //alert(1);  
      //hidePaypalButton();        
    }

    //checkConditionsAndAddToCart();
  
  document.addEventListener('click', function() {
    var observer = new MutationObserver(function(mutations) {
        if (checkProductDetails()) {
            //hidePaypalButton();
        }
        //checkConditionsAndAddToCart();
    });

    // Начинаем наблюдение за изменениями в DOM
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  });  

});


